/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'

import { TicketsByAppGeneral } from './TicketsByAppGeneral/TicketsByAppGeneral'
import { TicketsByAppByStore } from './TicketsByAppByStore/TicketsByAppByStore'
import { GeneralMetrics } from './GeneralMetrics/GeneralMetrics'
import { LevelRegistrationEvolution } from './LevelRegistrationEvolution/LevelRegistrationEvolution'
import { NewVsReturning } from './NewVsReturning/NewVsReturning'
import { AverageFrequency } from './AverageFrequency/AverageFrequency'
import { Top3Redemptions } from './Top3Redemptions/Top3Redemptions'

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]
const years = [2022, 2023, 2024]

const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'client-scan', label: 'Client scan' },
  { key: 'loyalty', label: 'Loyalty efficiency' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'business', label: 'Business impact' },
]

export const NewDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview')
  const [period1, setPeriod1] = useState({ month: 0, year: 2024 })
  const [period2, setPeriod2] = useState({ month: 0, year: 2023 })

  return (
    <div className="flex flex-col gap-8 p-6 bg-gray-50 min-h-screen">
      {/* Header y Tabs */}
      <div className="mb-4">
        <h1
          className="text-2xl font-bold mb-2"
          style={{ fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }}
        >
          Dashboards
        </h1>
        <div className="flex gap-8 border-b border-gray-200">
          {TABS.map(tab => (
            <button
              key={tab.key}
              type="button"
              className={`pb-2 text-base font-semibold transition-colors duration-200 ${
                activeTab === tab.key
                  ? 'text-[#1E1E1E] border-b-2 border-[#1E1E1E]'
                  : 'text-gray-500 border-b-2 border-transparent hover:text-[#1E1E1E]'
              }`}
              style={{ fontFamily: 'Montserrat, sans-serif' }}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {/* Filtros de periodo alineados horizontalmente */}
        <div className="mt-4 flex flex-row items-end gap-8 w-full">
          <div className="flex-1 flex flex-row items-end gap-4">
            {/* Periodo 1 */}
            <div>
              <label className="block text-xs font-semibold mb-1">Periodo (mes)</label>
              <select
                className="border rounded p-1 w-32"
                value={period1.month}
                onChange={e => setPeriod1({ ...period1, month: Number(e.target.value) })}
              >
                {months.map((m, i) => (
                  <option key={m} value={i}>
                    {m}
                  </option>
                ))}
              </select>
              <select
                className="border rounded p-1 w-24 mt-2"
                value={period1.year}
                onChange={e => setPeriod1({ ...period1, year: Number(e.target.value) })}
              >
                {years.map(y => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
            <span className="text-xs text-gray-500 mb-2">Comparar con</span>
            {/* Periodo 2 */}
            <div>
              <label className="block text-xs font-semibold mb-1">Periodo (mes)</label>
              <select
                className="border rounded p-1 w-32"
                value={period2.month}
                onChange={e => setPeriod2({ ...period2, month: Number(e.target.value) })}
              >
                {[
                  'Enero',
                  'Febrero',
                  'Marzo',
                  'Abril',
                  'Mayo',
                  'Junio',
                  'Julio',
                  'Agosto',
                  'Septiembre',
                  'Octubre',
                  'Noviembre',
                  'Diciembre',
                ].map((m, i) => (
                  <option key={m} value={i}>
                    {m}
                  </option>
                ))}
              </select>
              <select
                className="border rounded p-1 w-24 mt-2"
                value={period2.year}
                onChange={e => setPeriod2({ ...period2, year: Number(e.target.value) })}
              >
                {[2022, 2023, 2024].map(y => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
            {/* Checkbox */}
            <div className="flex items-center mb-2">
              <input type="checkbox" id="no-compara" className="mr-1" />
              <label htmlFor="no-compara" className="text-xs">
                No compara
              </label>
            </div>
          </div>
          {/* Botón aplicar */}
          <button
            type="button"
            className="bg-[#26342E] text-white rounded px-6 py-2 font-semibold ml-auto"
          >
            Aplicar
          </button>
        </div>
      </div>
      {/* Contenido del dashboard solo si Overview está activo */}
      {activeTab === 'overview' && (
        <>
          <TicketsByAppGeneral />
          <TicketsByAppByStore />
          <GeneralMetrics />
          <LevelRegistrationEvolution />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <NewVsReturning />
            <AverageFrequency />
          </div>
          <Top3Redemptions />
        </>
      )}
      {/* Puedes agregar aquí el contenido de los otros tabs en el futuro */}
    </div>
  )
}

export default NewDashboard
